module.exports = __webpack_public_path__ + "static/media/april_profile.d14ae65c.jpg";